import { RouteName } from '@shared/constants/routes'
import { isValidUuidFormat } from '@/features/shared/utils/validator'

/*
 * PDP is the one route whose RouteName depends on the VALUE of its param, not its shape.
 * a small share of products have no universal product (and therefore no UUID), so both
 * shapes are permanently served from /shop/products/[id]:
 * - /shop/products/<uuid>   -> universal product page
 * - /shop/products/<number> -> legacy product page
 *
 * these two helpers are the only place that distinction is defined. callers are the PDP
 * page itself and the discriminators map in matchRouteByPath.ts.
 */
export const resolveProductRouteName = (id: unknown): RouteName =>
  isUniversalProductId(id) ? RouteName.UNIVERSAL_PRODUCT : RouteName.PRODUCT

export const isUniversalProductId = (id: unknown): id is string =>
  typeof id === 'string' && isValidUuidFormat(id)
